import { render, staticRenderFns } from "./br.vue?vue&type=template&id=7d1d7b11&scoped=true"
import script from "./br.vue?vue&type=script&lang=js"
export * from "./br.vue?vue&type=script&lang=js"
import style0 from "./br.vue?vue&type=style&index=0&id=7d1d7b11&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d1d7b11",
  null
  
)

export default component.exports